import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
/**
 * Service used to set the Event 
 */
@Injectable({
  providedIn: 'root'
})
export class ClientService {
  /**
   * 
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }
  /**
   * Get the Client config
   * @returns 
   */
  getClient() {
    return this.http.get(`${this.environment.getApiUrl()}`);
  }
  /**
   * Get the Adress of the Client
   * @returns 
   */
  getClientAddress() {
    return this.http.get(`${this.environment.getApiUrl()}/address`);
  }

  /**
   * Get the Coordinates to an Adress
   * @deprecated
   * @param address 
   */
  getGoogleAddressCoordinates(address) {
    console.log('TODO: implement google lookup');
    // return this.http.get('https://maps.google.com/maps/api/geocode/json?address=' +
    // address.street.replace(' ', '+') + ',' +
    // address.postcode + '+' +
    // address.city + '&sensor=false' +
    // '&key=AIzaSyB4v4vmwF2tKLVT3yKAg4NLLn9Zlt-qEUQ');
  }
  /**
   * Get the Attachment File
   * @param id 
   * @returns 
   */
  getAttachmentURL(id) {
    return `${this.environment.getApiUrl()}/attachment/${id}/file`;
  }
  /**
   * Get the URL to a File
   * @param id 
   * @returns 
   */
  getFileURL(id) {
    return `${this.environment.getApiPlain()}/${id}/file`;
  }
  /**
   * Update the Client 
   * @param client 
   * @returns 
   */
  updateClient(client) {
    return this.http.put(`${this.environment.getApiUrl()}`, client);
  }
  /**
   * Update the Adress of the Client
   * @param address 
   * @returns 
   */
  updateClientAddress(address) {
    return this.http.put(`${this.environment.getApiUrl()}/address`, address);
  }

}
